import Vue from 'vue'

const treeWindowEventHandler = new Vue({
  data () {
    return {
      folderLoadFinished: null
    }
  },
  created () {
    let self = this
    // this event gets fired when a folder finished loading
    window.addEventListener('folderLoadFinishedEvent', e => {
      self.folderLoadFinished = !self.folderLoadFinished
    })
  }
})

export default treeWindowEventHandler



// WEBPACK FOOTER //
// ./src/api/treeWindowEventHandler.js